const URLS = {

	/*base_url*/
	// BASE_URL : "https://139.59.10.42/api/",
	BASE_URL : "https://api.themedx.in/api/",
	// BASE_URL : "https://dev.api.themedx.in/api/",
	// BASE_URL : "http://127.0.0.1:8888/api/",


	HOST_NAME:"http://localhost:8080/",

	/* paytm*/
	// PAYTM_SHOW_PAYMENT_PAGE:"https://securegw-stage.paytm.in/theia/api/v1/showPaymentPage",

	PAYTM_SHOW_PAYMENT_PAGE:"https://securegw-stage.paytm.in/theia/api/v1/showPaymentPage?mid=jhfvgo46572927804945&orderId=MEDX20200925ODR70",

	WELCOME_SCREEN:"onboarding/welcome-screen/",

	LOGIN : "user/login/",
	VERIFY:"user/verify/",
	RESEND_OTP:"user/resend-otp/",
	FORGET_PASSWORD:"user/forget-password/",
	RESET_PASSWORD:"user/reset-password/",
	GET_NOTIFICATION_LIST:"user/get-notification-list/",

	/* whole Saler API*/ 
	WHOLESALER_HOME:"wholesaler/dashboard/",
	REGISTER_WHOLESALER:"wholesaler/registration/",
	WHOLESALER_PROFILE:"wholesaler/profile/",
	WHOLESALER_EDIT:"wholesaler/edit/",
	WHOLESALER_LIST:"wholesaler/list/",
	WHOLESALER_CHANGE_VERIFIACATION_STATUS:"wholesaler/change-wholesaler-verification-status/",

	/* WareHouse */ 
	WAREHOUSE_DASHBOARD:"warehouse/dashboard/",


	/* Maters API */ 
	MASTER_CONTACT_US:"/master/contact_us/",
	MASTER_FAQ:"/master/faq/",
	MASTER_MANUFACTURER_LIST:"master/get-manufacturer-list/",
	MASTER_FORMULA_LIST:"master/get-formula-list/",
	UPLOAD_PRODUCT_EXCEL:"master/upload-product-excel/",
	DOWNLOAD_PRODUCT_EXCEL:"master/download-product-excel/",
	LINE_LIST:"master/line-list/",
	CREATE_LINE:"master/create-line/",
	EDIT_LINE:"master/edit-line/",
	LINE_DETAILS:"master/line-details/",
	DELETE_LINE:"master/delete-line/",
	CITY_LIST:"master/get-city-list/",



	/*shipment */ 
	CREATE_SHIPMENT:"shipment/create/",
	SHIPMENT_LIST:"shipment/list/",
	SHIPMENT_DETAILS:"shipment/details/",
	CHANGE_SHIPMENT_STATUS:"shipment/change-shipment-status/",
	CREATE_BULK_SHIPMENT:"shipment/bulk-create/",
	GET_PDF:"shipment/get-pdf/",
	SHARE_PDF:"shipment/share-pdf/",
	SHIPMENT_CSV:"shipment/get-csv/",
	WITHDRAW_CSV:"shipment/withdraw/get-csv/",
	GET_DISPATCH_LIST:"shipment/get-dispatch-list/",
	DISPATCH_SHIPMENT:"shipment/create-trip/",
	COMPLETE_WITHDRAW:"shipment/complete-withdraw/",
	REASSIGN_TRIP:"shipment/reassign-trip/",
	GET_ACCEPT_SHIPMENT_LIST:"shipment/get-accept-shipment-list/",
	ACCEPT_SHIPMENT:"shipment/accept-shipment/",

	DROP_SHIPMENT_LIST:"shipment/drop-shipment-list/",
	DROP_SHIPMENT:"shipment/drop-shipment/",


	// whidthdrawal
	WITHDRAWAL_HISTORY:"shipment/get-withdrawal-history/",
	WITHDRAWAL_SHIPMENT_LIST:"shipment/get-withdrawal-list/",
	INITIATE_WITHDRAW:"shipment/initiate-withdraw/",
	VERIFY_WITHDRAW:"shipment/verify-withdraw/",
	WITHDRAW_RESEND_OTP:"shipment/resend-otp/",
	WITHDRAW_DETAILS:"shipment/withdraw-details/",
	WITHDRAW_GET_PDF:"shipment/withdraw/get-pdf/",
	GET_TRIP_HISTORY:"shipment/get-trip-history/",
	TRIP_DETAILS:"shipment/trip-details/",
	COLLECT_TRIP:"shipment/collect-trip/",
	VERIFY_DEPOSIT:"shipment/verify-deposit/",
	DEPOSIT_HISTORY:"/shipment/get-deposit-history/",
	DEPOSIT_DETAILS:"/shipment/deposit-details/",
	GET_COLLECTION_TRIP_LIST:"/shipment/get-collection-trip-list/",



	/* Other*/
	CONTACT_DETAILS:"master/contact-details/",


	RAISE_ISSUE:"ticket/raise-ticket/",
	TICKET_LIST:"ticket/ticket-list/",
	TICKET_DETAILS:"ticket/ticket-details/",
	CLOSE_TICKET:"ticket/close-ticket/",
	ADD_COMMENT:"ticket/add-comment/",
	TICKET_CATEGORY_LIST:"ticket/ticket-category-list/",


	/* Product */ 

	CREATE_PRODUCT:"master/create-product/",
	PRODUCT_LIST:"master/get-product-list/",
	PRODUCT_DETAILS:"master/product-details/",
	EDIT_PRODUCT:"master/edit-product/",
	DELETE_PRODUCT:"master/delete-product/",

	/* subscription*/

	SUBSCRIPTON_LIST:"transactions/get-subscription-plan-list/", 
	SUBSCRIPTON_HISTORY:"transactions/get-subscription-history/", 
	SUBSCRIPTION_INVOICE:"subscription/get-subscription-invoice/", 

	CREATE_SUBSCRIPTON_PLAN:"transactions/create-subscription-plan/", 
	SUBSCRIPTION_PLAN_DETAILS:"transactions/subscription-plan-details/", 
	EDIT_SUBSCRIPTION_PLAN:"transactions/edit-subscription-plan/", 
	DELETE_SUBSCRIPTION_PLAN:"transactions/delete-subscription-plan/", 
	CONFIRM_OFFLINE_PAYMENT:"transactions/confirm-offline-payment/",
	GET_DIRECT_SUBSCRIPTION:"transactions/get-direct-subscription/",
	/* add on  plans*/
	PURCHASE_ADDON_PLAN:"transactions/purchase-addon-plan/",
	INITIATE_PAYMENT_FOR_ADDON:"transactions/initiate-payment-for-addon/",
	GET_PAYOUT_CSV:"transactions/get-payout-csv/",

	GET_PAYOUT_DETAILS:"transactions/get-payout-details/",


	INITIATE_PAYMENT:"transactions/initiate-payment/",
	CONFIRM_PAYMENT:"transactions/confirm-payment/",
	GET_SUBSCRIPTION_HISTORY_CSV:"transactions/get-subscription-history-csv/",

	/*AGENTS*/ 
	ADD_AGENT:"agent/registration/",
	EDIT_AGENT:"agent/edit/",
	AGENT_LIST:"agent/list/",
	AGENT_PROFILE:"agent/profile/",
	CHANGE_AGENT_STATUS:"agent/change-agent-status/",
	GET_AGENT_LOCATION:"agent/get-agent-location/",
	CHANGE_AGENT_PAYOUT_STATUS:"agent/change-agent-payout-status/",
	AGENT_LIST_FOR_PAYOUT:"agent/agent-list-for-payout/",


	/* Retailer */ 
	RETAILER_MANAGE_LIST:"retailer/manage/list/",
	RETAILER_LIST:"retailer/list/",
	REGISTER_RETAILER:"retailer/registration/",
	RETAILER_PROFILE:"retailer/profile/",
	EDIT_RETAILER:"retailer/edit/",
	CHANGE_RETAILER_VERIFICATION_STATUS:"retailer/change-retailer-verification-status/",
	RETAILER_LINE_DETAILS:"retailer/retailer-line-details/",
	CHANGE_RETAILER_LINE:"retailer/change-retailer-line/",
	MERGE_RETAILER:"retailer/merge-retailer/",

	/* Warehouse */ 

	CREATE_WAREHOUSE:"warehouse/create-warehouse/",
	WAREHOUSE_DETAILS:"warehouse/warehouse-details/",
	EDIT_WAREHOUSE:"warehouse/edit-warehouse/",
	DELETE_WAREHOUSE:"warehouse/delete-warehouse/",
	WAREHOUSE_LIST:"warehouse/list/",
	SEND_OTP_TO_WAREHOUSE:"warehouse/send-otp-to-warehouse/",
	TOGGLE_AUTO_ACCEPT:"warehouse/toggle-auto-accept/",

	/* Payouts */
	PAYOUT_HISTORY:"transactions/get-payout-history/",
	INITIATE_PAYOUT:"transactions/initiate-payout/",


	/* Images */
	CREATE_WHOLESALER_DASHBOARD_IMAGES:"wholesaler/create-wholesaler-dashboard-images/",
	GET_WHOLESALER_DASHBOARD_IMAGES:"wholesaler/get-wholesaler-dashboard-images/",
	DELETE_WHOLESALER_DASHBOARD_IMAGES:"wholesaler/delete-wholesaler-dashboard-images/",
	
	GET_WHOLESALER_DASHBOARD_IMAGES_DETAIL:"wholesaler/get-wholesaler-dashboard-images-detail/",
	EDIT_WHOLESALER_DASHBOARD_IMAGES:"wholesaler/edit-wholesaler-dashboard-images/",

	CREATE_RETAILER_DASHBOARD_IMAGES:"retailer/create-retailer-dashboard-images/",
	GET_RETAILER_DASHBOARD_IMAGES:"retailer/get-retailer-dashboard-images/",
	DELETE_RETAILER_DASHBOARD_IMAGES:"retailer/delete-retailer-dashboard-images/",

};
export default URLS;	
